import type { Character } from '@/types/character';

export const mikaela: Character = {
  v: 1,
  type: 'grog',
  name: 'Mikaela',
  age: 28,
  gender: 'Female',
  nativeLanguage: 'French',
  size: 0,
  appearance:
    '179 cm, 75 kg, brown/green eyes, black hair. Travelling childhood. Pagan.',
  characteristics: {
    intelligence: 2,
    perception: 1,
    strength: -1,
    stamina: 1,
    presence: 1,
    communication: 2,
    dexterity: -1,
    quickness: 0,
  },
  virtues: [
    { id: 'clerk' },
    { id: 'common-sense' },
    { id: 'covenfolk' },
    { id: 'social-contacts', subject: 'Academics' },
  ],
  flaws: [
    { id: 'humble' },
    { id: 'magical-fascination' },
    { id: 'short-of-breath' },
  ],
  abilities: [
    { id: 'lore', xp: 30, specialization: 'France (Geography)' },
    { id: 'lore', xp: 5, specialization: 'Paris (Politics)' },
    { id: 'artes-liberales', xp: 15, specialization: 'Grammar' },
    { id: 'athletics', xp: 30, specialization: 'running' },
    { id: 'awareness', xp: 15, specialization: 'searching' },
    { id: 'bargain', xp: 30, specialization: 'Books' },
    { id: 'chirurgy', xp: 20, specialization: 'binding wounds' },
    { id: 'concentration', xp: 50, specialization: 'reading' },
    { id: 'etiquette', xp: 30, specialization: 'court' },
    { id: 'folk-ken', xp: 15, specialization: 'townsfolk' },
    { id: 'living-language', xp: 75, specialization: 'French' },
    { id: 'dead-language', xp: 50, specialization: 'Latin' },
    { id: 'magic-lore', xp: 5, specialization: 'magical traditions' },
    { id: 'medicine', xp: 15, specialization: 'Anatomy' },
    { id: 'philosophiae', xp: 15, specialization: 'metaphysics' },
    { id: 'profession', xp: 15, specialization: 'Scribe (Writing)' },
    { id: 'survival', xp: 50 },
  ],
  personality: [
    { name: 'Humble', score: 3 },
    { name: 'Brave', score: -3 },
    { name: 'Perfectionist', score: 2 },
    { name: 'Curious', score: 3 },
  ],
  reputations: [],
  warpingScore: 0,
  warpingPoints: 0,
  decrepitudeScore: 0,
  decrepitudePoints: 0,
  fatigueLevel: 0,
  wounds: { light: 0, medium: 0, heavy: 0, incapacitated: 0 },
  covenant: { name: 'Ex Astra', role: 'Scholar', joined: 1195 },
  grog: {},
  notes:
    "Player: Sylly. Profession: Scholar. Religion: Pagan. Joined Ex Astra in 1195. Current saga: Not-Quite-Free Real Estate — spring scouting mission for a secondary magical site, with ingredient-gathering on the return. House rules: magical items are not toys; never wander alone; avoid mushroom circles; do not give the mundanes a reason.",
  updatedAt: '2026-04-19T00:00:00.000Z',
};
